import { Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { voiceDashboardCards } from '@/config/voiceNav'
import { cn } from '@/utils/cn'

export default function HomePage() {
  const { profile, attendant } = useAuth()
  const displayName =
    attendant?.name || attendant?.email || profile?.full_name || profile?.email || ''

  return (
    <div className="w-full min-w-0 space-y-8">
      <div className="w-full">
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
          Olá{displayName ? `, ${displayName.split(' ')[0]}` : ''}
        </h1>
        <p className="mt-2 w-full text-muted-foreground text-sm sm:text-base">
          Telefonia em nuvem integrada ao atendimento. Escolha uma área abaixo ou use o menu superior.
        </p>
      </div>

      <ul className="grid w-full min-w-0 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {voiceDashboardCards.map(({ path, title, description, icon: Icon }) => (
          <li key={path}>
            <Link
              to={path}
              className={cn(
                'block h-full rounded-xl border border-border bg-card p-5 shadow-sm outline-none',
                'transition-shadow hover:shadow-md focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                'touch-manipulation'
              )}
            >
              <div className="flex gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon className="h-5 w-5" aria-hidden />
                </span>
                <div className="min-w-0">
                  <h2 className="font-semibold text-foreground">{title}</h2>
                  <p className="mt-1 text-sm text-muted-foreground">{description}</p>
                  <span className="mt-3 inline-block text-sm font-medium text-primary">Abrir</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
